import { Layer } from 'leaflet';
import { Feature } from './feature';
import { LayerConfig } from '../layers/layers.config'

export class FeatureInfo {
    layerName:string;
    layerConfig: LayerConfig;
    features=new Array<Feature>();
}
